var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 24.21L4.38 22.13C1.203 20.702 1.21 17.295 4.38 15.87L20.275 8.716C22.398 7.761 25.605 7.762 27.725 8.716L43.621 15.869C46.797 17.299 46.789 20.705 43.621 22.131L39 24.21V32.5C39 37.113 32.175 40 24 40C15.825 40 9 37.113 9 32.5V24.21ZM35 26.01L27.725 29.284C25.602 30.239 22.395 30.238 20.275 29.284L13 26.01V32.5C13 32.978 13.823 33.8 15.587 34.547C17.747 35.461 20.759 36 24 36C27.24 36 30.253 35.46 32.413 34.547C34.177 33.801 35 32.977 35 32.5V26.01ZM26.084 12.364C25.007 11.879 22.995 11.878 21.916 12.364L7.17 19L21.917 25.636C22.994 26.121 25.006 26.122 26.085 25.636L40.83 19L26.084 12.364Z",
    fill: "#39585C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIconDark);
export default __webpack_public_path__ + "static/media/schoolIconDark.2be6599023b8d6a817dd00852f4d2b4f.svg";
export { ForwardRef as ReactComponent };